// =============================================================================
// Business facts used for SEO (titles, footer NAP, JSON-LD, click-to-call).
// Only facts that the site already states belong here. Anything the site
// does not state is `null` with a TODO — those fields are left out of the
// published schema until the owner fills them in.
// =============================================================================

export const SITE_URL = "https://transportes-cgmg.com";

export const NAP = {
  name: "Transportes CGMG",
  // Exactly as in the contact section ("Oficinas corporativas").
  streetAddress: "Calle 23 Nte. 404, Industrial Nte.",
  locality: "Delicias",
  region: "Chihuahua",
  postalCode: "33000",
  country: "MX",
  addressLine: "Calle 23 Nte. 404, Industrial Nte., 33000 Delicias, Chihuahua",
  // From the company CV (src/data/content.js `primaryPhoneDisplay`).
  // TODO(owner): confirm this is the public office number and that it has WhatsApp.
  phoneDisplay: "639 474 2183",
  phoneE164: "+526394742183",
  email: "contacto@transportescgmg.com",
};

// TODO(owner): opening hours are not published anywhere on the site.
// Format when known: [{ days: ["Monday", ...], opens: "08:00", closes: "18:00" }]
export const OPENING_HOURS = null;

// TODO(owner): exact coordinates of the office (from Google Maps / the
// Google Business Profile pin). Format: { latitude: 28.19, longitude: -105.47 }
export const GEO = null;

export const telHref = `tel:${NAP.phoneE164}`;
export const whatsappHref = (text) =>
  `https://wa.me/${NAP.phoneE164.replace(/\D/g, "")}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const mapsEmbedSrc = `https://www.google.com/maps?q=${encodeURIComponent(
  `${NAP.name}, ${NAP.addressLine}`
)}&output=embed`;
export const mapsHref = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(NAP.addressLine)}`;
